import * as angular from 'angular';
import * as _ from 'lodash';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import BatchFormulasServiceName, {BatchFormulasService} from "../../services/batches/batchFormulas.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsCommon} from "../../shared/dto/aps.common";
import template from './updateBatchFormula.tpl.html';

let requires = [BatchFormulasServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName];

interface UpdateBatchFormulaController {
  glassColors: apsCommon.IdAndName[];
  commodities: apsViewModels.CommodityItem[];
  save(): void;
  addMaterial(): void;
  removeMaterial(material: apsViewModels.BatchMaterialItem): void;
  cancel(): void;
}

export interface UpdateBatchFormulaParams {
  instance: apsViewModels.BatchFormulaDetail;
  glassColors: apsCommon.IdAndName[];
  commodities: apsViewModels.CommodityItem[];
  allBatchFormulas: apsViewModels.BatchFormulaItem[];
}

export function openUpdateBatchFormula(data: UpdateBatchFormulaParams,
                                    $modal: mm.foundation.modal): angular.IPromise<apsViewModels.BatchFormulaDetail> {
  return $modal.open({
    template: template,
    controller: 'UpdateBatchFormulaCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class UpdateBatchFormulaCtrl implements UpdateBatchFormulaController {
  instance: apsViewModels.BatchFormulaDetail;
  glassColors: apsCommon.IdAndName[];
  commodities: apsViewModels.CommodityItem[];
  form: angular.IFormController;
  allBatchFormulas: apsViewModels.BatchFormulaItem[];

  private $modalInstance: mm.foundation.modalInstance;
  private batchFormulasService: BatchFormulasService;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  private newGuidService: NewGuidService;
  private newId: string;

  constructor(
    $modalInstance: mm.foundation.modalInstance,
    batchFormulasService: BatchFormulasService,
    data: UpdateBatchFormulaParams,
    notifyService: NotifyService,
    newGuidService: NewGuidService,
    loaderService: LoaderService
  ) {
    this.$modalInstance = $modalInstance;
    this.batchFormulasService = batchFormulasService;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.newGuidService = newGuidService;

    this.instance = {...data.instance};
    this.commodities = data.commodities;
    this.glassColors = data.glassColors;

    this.loaderService.loadingPromise(this.newGuidService.getNewGuid('BatchFormula')
      .then(id => this.newId = id));
  }

  save(): void {
    if (this.form.$invalid) {
      return;
    }

    let command = <apsCommands.UpdateBatchFormula> {
      ...this.instance,
      newId: this.newId
    };

    this.loaderService.loadingPromise(this.batchFormulasService.update(command)
      .then(() => {
        this.instance.id = this.newId;
        this.instance.colorName = _.find(this.glassColors, {id: this.instance.colorId}).name;
        this.$modalInstance.close(this.instance);
      }, this.notifyService.handleApiErrors)
    );
  }
  
  addMaterial(): void {
    let material = <apsViewModels.BatchMaterialItem>{};
    this.loaderService.loadingPromise(this.newGuidService.getNewGuid('BatchMaterial')
      .then(id => {
        material.id = id;
        this.instance.material.push(material);
      }));
  }

  removeMaterial(material: apsViewModels.BatchMaterialItem): void {
    _.remove(this.instance.material, material);
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.updateBatchFormula', requires)
  .controller('UpdateBatchFormulaCtrl', UpdateBatchFormulaCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/updateBatchFormula.controller.ts